import { ReactComponent as AboutUs } from '../../assets/svgs/AboutUsIcon.svg';
import { ReactComponent as Activity } from '../../assets/svgs/ActivityIcon.svg';
import { ReactComponent as ArrowRightFill } from '../../assets/svgs/ArrowRightFillIcon.svg';
import { ReactComponent as ArrowRight } from '../../assets/svgs/ArrowRightIcon.svg';
import { ReactComponent as Book } from '../../assets/svgs/Book.svg';
import { ReactComponent as ChevronDown } from '../../assets/svgs/ChevronDownIcon.svg';
import { ReactComponent as ChevronLeft } from '../../assets/svgs/ChevronLeftIcon.svg';
import { ReactComponent as ChevronRight } from '../../assets/svgs/ChevronRightIcon.svg';
import { ReactComponent as ChevronUp } from '../../assets/svgs/ChevronUpIcon.svg';
import { ReactComponent as CloseQuote } from '../../assets/svgs/CloseQuoteIcon.svg';
import { ReactComponent as DocumentCopy } from '../../assets/svgs/DocumentCopy.svg';
import { ReactComponent as Document } from '../../assets/svgs/DocumentIcon.svg';
import { ReactComponent as DocumentShare } from '../../assets/svgs/DocumentShare.svg';
import { ReactComponent as Exercise } from '../../assets/svgs/ExerciseIcon.svg';
import { ReactComponent as FacebookIcon } from '../../assets/svgs/FacebookIcon.svg';
import { ReactComponent as Help } from '../../assets/svgs/HelpIcon.svg';
import { ReactComponent as Home } from '../../assets/svgs/HomeIcon.svg';
import { ReactComponent as Introduction } from '../../assets/svgs/IntroductionIcon.svg';
import { ReactComponent as Library } from '../../assets/svgs/LibraryIcon.svg';
import { ReactComponent as LocationIcon } from '../../assets/svgs/LocationIcon.svg';
import { ReactComponent as LogoCTCT } from '../../assets/svgs/LogoCTCT.svg';
import { ReactComponent as LogoGDSC } from '../../assets/svgs/LogoGDSC.svg';
import { ReactComponent as Logout } from '../../assets/svgs/LogoutIcon.svg';
import { ReactComponent as MailIcon } from '../../assets/svgs/MailIcon.svg';
import { ReactComponent as OpenQuote } from '../../assets/svgs/OpenQuoteIcon.svg';
import { ReactComponent as Partner } from '../../assets/svgs/PartnerIcon.svg';
import { ReactComponent as PhoneIcon } from '../../assets/svgs/PhoneIcon.svg';
import { ReactComponent as Profile } from '../../assets/svgs/ProfileIcon.svg';
import { ReactComponent as Quiz } from '../../assets/svgs/QuizIcon.svg';
import { ReactComponent as Result } from '../../assets/svgs/ResultIcon.svg';
import { ReactComponent as Room } from '../../assets/svgs/RoomIcon.svg';
import { ReactComponent as Search } from '../../assets/svgs/SearchIcon.svg';
import { ReactComponent as Test } from '../../assets/svgs/TestIcon.svg';
import { ReactComponent as YoutubeIcon } from '../../assets/svgs/YoutubeIcon.svg';

export default {
  AboutUs,
  Activity,
  ArrowRightFill,
  ArrowRight,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Book,
  ChevronUp,
  Document,
  DocumentCopy,
  DocumentShare,
  FacebookIcon,
  LocationIcon,
  LogoCTCT,
  LogoGDSC,
  Exercise,
  PhoneIcon,
  MailIcon,
  Help,
  Home,
  Introduction,
  Library,
  Logout,
  Partner,
  Quiz,
  OpenQuote,
  CloseQuote,
  Result,
  Room,
  Search,
  Test,
  Profile,
  YoutubeIcon,
};
